const TEXT = {
  REWARDS: {id: 'mgm.referral2.rewards'},
  TEXT: {id: 'mgm.referral2.text'},
  TITLE: {id: 'mgm.referral2.title'},
  SUMMARY_CTA: {id: 'mgm.referral2.cta2'},
};

export {TEXT};
